module.exports = "https://web-assets.ifttt.com/packs/media/location_field/location_radius-93f4f016.svg";